<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="intro_box cont840">
	<div class="title_2">关于Luara</div>
	<hr class="hr_1">
	<img src="static/picture/story_1.jpg">
	<p class="mt20">
	Luara，是日本的护肤品品牌，旨在从根源出发调理肌肤，探索肌肤光感净透之美。</p>
<p class="mt20">
	Luara，犹如晨曦之光，用永恒的匠心精神带给你如光般永恒的肌肤。</p>
<hr class="hr_1 mt40" />
<dl class="dl_basic">
	<dt>
		<img src="static/picture/basic_1.jpg" /></dt>
	<dd>
		<h1>
			基本信息</h1>
		<p class="mt20">
			品牌名称：Luara<br />
			<br />
			日文名称： ルアラ<br />
			<br />
			所属行业：护肤<br />
			<br />
			国&nbsp;&nbsp;&nbsp;&nbsp;家：日本<br />
			<br />
			日本官网：<a class="a_link" href="https://luara.co.jp/">https://luara.co.jp/</a><br />
			<br />
			&nbsp;</p>
	</dd>
</dl>
<hr class="hr_1 mt40" />
<h1>
	品牌故事</h1>
<h1 class="mt20">
	FACET THE LIGHT OF SKIN</h1>
<p class="mt20">
	Luara这个美好的名字来源于法语词&ldquo;LUEUR微光&rdquo;。<br />
	<br />
	是来自日出之国的微光，是清晨朦胧的光，也是蕴含希望之光。<br />
	<br />
	是一道跨越时间和空间，唤醒每一位女性肌肤的微光。</p>
<p class="mt20">
	Luara，起源于昭和43年。70年代前后，日本本土的化妆品品牌日渐觉醒，日本女性审美也从欧美潮流主导转向了追求&ldquo;日式的美丽&rdquo;。<br />
	<br />
	创始人赤松庆一先生也开始投身日本的美容行业，潜心专研，致力于让更多日本女性发现自己的光芒。</p>
<hr class="hr_1 mt40" />
<h1>
	品牌传承</h1>
<h1 class="mt20">
	&middot;匠人精神</h1>
<p>
	Luara，视&ldquo;匠心&rdquo;为灵魂，将传世当做天命，以精纯的匠义之心去发现和了解美，守护技艺和生活，让你的肌肤也可以细细品味时光的滋润。</p>
<h1 class="mt20">
	&middot;永恒之光</h1>
<p>
	&ldquo;Luara&rdquo;，在法语里面有&ldquo;发光的肌肤&rdquo;之意。</p>
<p>
	Luara始终坚守品牌创立伊始的灵感之光和匠心，每个细节都用心推敲打磨，努力研发，沉淀技艺，只为了让爱美人士实现如光般永恒的肌肤。</p>
<h1 class="mt20">
	&middot;真实性</h1>
<p>
	Luara，承诺给予消费者纯正的日式护肤体验。</p>
<p>
	Luara，成就如光般透明的真实美丽。</p>
<hr class="hr_1 mt40" />
<h1>
	品牌理念</h1>
<p class="mt20">
	倡导女性探索美、挖掘美、追求内心独有的美，拥有更积极的人生态度。为爱美人士打造水润明亮、具有通透感的肌肤。</p>
<h1 class="mt30">
	品牌定位</h1>
<p class="mt20">
	针对亚洲女性肤质，提供细腻、温和的肌肤护理产品，实现女性对肌肤通透感、光泽度、弹性度的追求。<br />
	<br />
	为热爱生活，时尚独立的女性群体，带来更丰富自信的生活方式。</p>
<hr class="hr_1 mt40" />
<h1>
	发展历程</h1>
<!-- <p class="mt20">
	诞生于日本；2010年，明星产品Luara肌底液面世，为爱美人士提供主打肌底修护的基础护肤产品；</p>
<p>
	2016年起，推出全线基础护肤系列产品；</p>
<p>
	2017年，正式进入大中华区，并在日系护肤市场占有一席之地；</p>
<p>
	2018年起，陆续受邀参与各大国际展会，崭露头角；</p>
<p>
	2019年，入驻日本高岛屋开设品牌专柜；</p>
<p>
	2019年，日本美容教母佐伯千津成为Luara品牌顾问；同年11月推出联名产品Luara佐伯水；</p>
<p>
	2019年-2020年，陆续在日本各大一线商场设立快闪店和专柜；</p>
<p>
	2020年，大中华区市场不断扩张，在上海伊势丹开设中国首个专柜，并参展上海CBE（美容博览会）；其后还将陆续入驻一线城市高端商场。</p> -->

	<p class="mt20">
		秉持着“想要为客户找到一款真正【有效】的护肤品，实现世人的驻颜梦想”的初心，Luara创始人赤松庆一社长联合SC研究院，共同研发出Luara第一款产品——肌底液。</p>
<p>
	2010年，明星产品Luara肌底液面世，为爱美人士提供主打肌底修护的基础护肤产品；</p>
<p>
	2013年，第一代肌底液迭代升级，同年Luara第一代化妆水也经过潜心研发后诞生；</p>
<p>
	2016年，为了让更多的人拥有变美的可能，Luara开始筹备引入大众市场，同年，Luara肌底液跨出历史性的一步，添加了高浓度的培养液成分；</p>
<p>
	2017年，Luara产品创始人赤松庆一与LEWA株式会社达成品牌战略合作，由此开始Luara由LEWA株式会社负责运营。同年推出全线基础护肤系列产品，在日系护肤市场占有一席之地，逐步开启Luara品牌化之路；</p>
<p>
	2017年，Luara肌底液全新升级；</p>
<p>
	2018年，LEWA株式会社会邀请福山昌盛（曾任日本佳丽宝英国公司社长、LVMH集团GIVENCHY社长）作为Luara的品牌顾问，同步由香椎化学工业株式会社为Luara全线产品做监制，并且协同佐伯千津老师为Luara拓新；</p>
<p>
	2018年，LEWA株式会社在中国设立日运（福建）贸易有限公司，开拓Luara的中国市场，同年品牌产品线延伸，推出平衡面霜等基础护肤产品，并陆续受邀参与各大国际展会，逐步拓展品牌知名度；</p>
<p>
	2019年，邀请日本美容教母佐伯千津为Luara品牌美容顾问，与品牌携手推出Luara×佐伯千津系列，同年11月推出联名产品Luara佐伯水;</p>
<p>
	2020年，Luara推出系列新品涂抹面膜、去角质霜；</p>
<p>
	2021年，Luara推出美妆系列，上新Luara隔离霜，同年持续上新Luara眼霜、佐伯乳液、佐伯面霜，晶泽系列面霜、精华也相继上市。</p>
<!-- <hr class="hr_1 mt40" /> -->
<hr class="hr_1 mt40" />
<dl>
	<dt>
		<img src="static/picture/starpro.jpg" /></dt>
	<dd>
		<h1>
			明星产品</h1>
		<h2 class="mt30">
			肌底液</h2>
		<p>
			从肌底着手，发现肌肤问题，改善肤质，同时打开了肌肤吸收通路，提升后续护肤品功效，维持皮肤平衡状态，让皮肤焕发健康水嫩，透亮。</p>
		<p class="mt30">
			日本&ldquo;不老仙妻&rdquo;水谷雅子曾在博客里推荐过它，在中国众多明星艺人的vlog里也都曾出现过它的身影。</p>
	</dd>
</dl>
<hr class="hr_1 mt40" />
<h1>
	媒体评价</h1>
<p class="mt20">
	Luara曾受到过《and GIRL》、《anan》、《Poco&rsquo;ce》、《MAQUIA》、《BH》等众多日本时尚杂志的推荐，更获得《Poco&rsquo;ce》授予的2019年上半年最佳美容奖。</p>
<img class="mt20" src="static/picture/media_1.jpg" />
</div>
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {

  },
  methods: {
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 1110px){
    .cont840 {
        width: 840px;
        margin: 0 auto;
    }
}
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------about_intro.html  start----------------*/
.intro_box{
	overflow: hidden;
	padding: 40px 0 60px;
}
.intro_box img{
	display: block;
	margin: 0 auto;
	max-width: 100%;
}
.intro_box h1{
	color: #2e2e2e;
	font-size: 18px;
	font-family: Font_Medium;
}
.intro_box p{
	color: #2e2e2e;
	line-height: 26px;
	margin: 0;
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl{
	width: 100%;
	overflow: hidden;
}
.intro_box dl dt{
	float: left;
	width: 245px;
}
.intro_box dl.dl_basic dt{
	width: 560px;
}
.intro_box dl.dl_100 dt{
	float: inherit;
	width: 100%;
}
.intro_box dl dt img{
	max-width: 100%;
}

.intro_box dl dd{
	float: right;
	width: calc(100% - 270px);
	color: #2e2e2e;
}
.intro_box dl.dl_basic dd{
	width: calc(100% - 580px);
}
.intro_box dl.dl_100 dd{
	float: inherit;
	width: 100%;
}
.intro_box dl dd h2{
	margin-top: 0;
	font-size: 15px;
	font-family: Font_Medium;
}
.intro_box dl dd p{
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl dd h3{
	margin-top: 0;
	font-size: 18px;
	font-family: Font_Medium;
	overflow: hidden;
}
.intro_box dl dd span{
	display: inline-block;
	width: 400px;
	text-align: center;
	height: 54px;
	line-height: 50px;
	margin-right: 130px;
	color: #2e2e2e;
}
.intro_box dl dd i{
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Medium;
}
.intro_box dl dd em{
	width: 32px;
	height: 30px;
	display: block;
    float: left;
	/* background: url(../images/addr.png) no-repeat 0px 0px; */
}
.intro_box dl dd a{
	float: right;
	color: #2e2e2e;
	font-size: 12px;
    font-family: Font_Medium;
	margin-top: 20px;
	padding-right: 15px;
	/* background: url(../images/more_jt.png) no-repeat right center; */
}
.intro_box dl dd a.a_link{
	float: inherit;
    font-family: Font_Medium;
	margin-top: 0;
	background: none;
}
/*------------about_intro.html  end----------------*/

</style>


// WEBPACK FOOTER //
// src/view/plus/about.vue